module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#fdf246","theme_color":"#fdf246","display":"minimal-ui","icon":"src/images/icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"7e42471ab11453f0db18fca984442917"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
